import axios from "axios";

const API_URL = "https://backend.gouniquejourneys.co.uk/api/employee/services"; // Update with actual backend URL

export const fetchEmployeeServices = async (page = 1, limit = 5, sortBy = "newest") => {
  try {
    const response = await axios.get(`${API_URL}/get-services?page=${page}&limit=${limit}&sortBy=${sortBy}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee services:", error);
    throw error;
  }
};
